import { Box, Button, List, Skeleton } from '@mui/material';
import { StyledContentContainer } from '../style';
import { StyledMenu, StyledHeader } from '../style';
import SearchToolbar from './SearchToolbar';
import theme from 'styles/theme';
import MenuRecords from '../MenuDrawer/MenuRecords';
import { useRef } from 'react';
import Header from './Header';
import DropdownMenu from 'routes/Main/DisplayInformation/DropdownMenu';
import useSelectorTyped from 'store/useSelectorTyped';
import MedicalNote from './MedicalNote';
import NursingRecord from './NursingRecord';
import InputInformation from './InputInformation';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
  coachRefA: any;
  coachRefB: any;
  coachRefC: any;
  coachRefD: any;
}

const DisplayInformation = (props: Props) => {
  const { menuDrawerWidth, coachRefA, coachRefB, setMenuDrawerWidth } = props;

  const patientInfo = useSelectorTyped(state => {
    return state.patient.patientInfo;
  });

  const containerWidth = {
    xs:
      menuDrawerWidth !== 300
        ? `calc(100% )`
        : `calc(100% - ${menuDrawerWidth}px )`,
    xl:
      menuDrawerWidth !== 300
        ? `calc(100% - ${menuDrawerWidth}px )`
        : `calc(100% - ${menuDrawerWidth}px )`,
  };

  const menuBox = {
    xs: menuDrawerWidth !== 300 ? `calc(100%)` : `calc(100% - 88px)`,
    xl: menuDrawerWidth !== 300 ? `calc(100% - 88px)` : `calc(100% - 88px)`,
  };

  const ref = useRef<HTMLElement>(null);

  const scrollHorizon = (width: number) => {
    if (ref.current) {
      ref.current.scrollLeft += width;
    }
  };

  const Content = () => {
    const contentBoxProps = {
      display: 'flex',
      // mt: 0.5,
      columnGap: 3,
      overflow: 'hidden',
      height: '100%',
    };

    if (!patientInfo) {
      return (
        <Box {...contentBoxProps}>
          <Box flex={1} display="flex" flexDirection="column" overflow="auto">
            <Skeleton variant="rectangular" sx={{ flex: 1 }} />
          </Box>
          <Box flex={1} display="flex" flexDirection="column" overflow="auto">
            <Skeleton variant="rectangular" sx={{ flex: 1 }} />
          </Box>
        </Box>
      );
    }

    return (
      <Box
        {...contentBoxProps}
        sx={{
          ...(contentBoxProps as any)?.sx,
          width: '100%',
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <MedicalNote patientInfo={patientInfo} />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <NursingRecord patientInfo={patientInfo} />
        </Box>

        <Box sx={{ flex: '0 0 530px', minWidth: 0 }}>
          <InputInformation
            coachRefA={coachRefA}
            coachRefB={coachRefB}
            menuDrawerWidth={menuDrawerWidth}
            setMenuDrawerWidth={setMenuDrawerWidth}
          />
        </Box>
      </Box>
    );
  };

  return (
    <Box
      display="flex"
      component="main"
      flexDirection="column"
      width={containerWidth}
    >
      <Box
        sx={{
          whiteSpace: 'pre-wrap',
          backgroundColor: '#B1CCF5',
          lineHeight: '34px',
          height: '80px',
          paddingTop: '5px',
          justifyContent: 'right',
          display: 'flex',
          direction: 'row',
          // paddingBottom: '20px',
        }}
      >
        <StyledHeader>
          <List>
            <Header />
          </List>
        </StyledHeader>
        <DropdownMenu target="ㅎㅎ" />
      </Box>
      <Box
        className="userDiv"
        sx={{
          whiteSpace: 'pre-wrap',
          backgroundColor: '#B1CCF5',
          lineHeight: '34px',
          height: '80px',
          paddingTop: '23px',
        }}
      >
        <SearchToolbar />
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        sx={{
          backgroundColor: '#B1CCF5',
          height: '130px',
        }}
      >
        <Box>
          <Button
            variant="contained"
            sx={{
              color: 'black',
              minWidth: '30px',
              height: '100px',
              backgroundColor: '#F2F4FF',
              marginTop: '15px',
              marginLeft: '0px',
              marginRight: '-4px',
              borderRadius: '5px',
              ':hover': {
                color: 'red',
                backgroundColor: '#E7EFFF',
              },
            }}
            onClick={() => scrollHorizon(-80)}
          >
            {'<'}
          </Button>
        </Box>
        <Box
          sx={{
            backgroundColor: '#F2F4FF',
            height: '100px !important',
            // width: '1060px',
            overflow: 'scroll',
            marginTop: '15px',
            borderRadius: '3px',
            display: 'flex',
            direction: 'row',
          }}
          width={menuBox}
          // ref={coachRefA}
          ref={ref}
        >
          <Box
            sx={{
              display: 'flex',
              direction: 'row',
            }}
            ref={ref}
          >
            <StyledMenu>
              <List>
                <MenuRecords
                  menuDrawerWidth={menuDrawerWidth}
                  setMenuDrawerWidth={setMenuDrawerWidth}
                  coachRef={coachRefB}
                />
              </List>
            </StyledMenu>
          </Box>
        </Box>
        <Box>
          <Button
            variant="contained"
            sx={{
              color: 'black',
              minWidth: '30px',
              height: '100px',
              backgroundColor: '#F2F4FF',
              marginTop: '15px',
              marginLeft: '-4px',
              marginRight: '-4px',
              ':hover': {
                color: 'red',
                backgroundColor: '#E7EFFF',
              },
            }}
            onClick={() => scrollHorizon(80)}
          >
            {'>'}
          </Button>
        </Box>
      </Box>

      <StyledContentContainer
        style={{
          display: 'flex',
          backgroundColor: `${theme.palette.primary.light}`,
        }}
      >
        <Content />
      </StyledContentContainer>
    </Box>
  );
};

export default DisplayInformation;
